import { StoryPointStatus } from 'magical-trails';
import {
  MarkerIcon,
  MarkerIconScanned,
  MarkerIconDisabled,
  MarkerIconQuestion,
  MarkerIconGeofenced,
} from 'magical-trails-assets';

export const generateMarkerIcon = (storyPointStatus: StoryPointStatus) => {
  if (storyPointStatus === 'completed') {
    return MarkerIconScanned;
  }
  if (storyPointStatus === 'locked') {
    return MarkerIconDisabled;
  }
  if (storyPointStatus === 'awaitingQuestionAnswer') {
    return MarkerIconQuestion;
  }
  if (storyPointStatus === 'geofenced') {
    return MarkerIconGeofenced;
  }
  return MarkerIcon;
};
